import { Box, Fade, Grid, Grid2Props, GridProps } from "@mui/material";
import MxLoading from "@rf-l1/loading/MxLoading";
import { rest } from "lodash";
import React, { memo } from "react";

interface MxListCasesRenderTemplateProps extends GridProps {
  isLoading: boolean;
  hasError: boolean;
  isEmpty: boolean;
  listComponent: React.ReactNode;
  errorComponent: React.ReactNode;
  emptyComponent: React.ReactNode;
  paginationComponent?: React.ReactNode;
  minHeight?: string;
}

const MxListCasesRenderTemplateTemplate = (
  props: MxListCasesRenderTemplateProps
) => {
  const {
    isLoading,
    hasError,
    isEmpty,
    listComponent,
    errorComponent,
    emptyComponent,
    paginationComponent,
    minHeight,
    ...rest
  } = props;

  return (
    <Grid
      container
      xs={12}
      item
      sx={{ height: minHeight || "auto" }}
      alignItems={isEmpty || hasError ? "center" : "flex-start"}
      justifyContent="center"
      gap={2}
      {...rest}
    >
      {isLoading && (
        <Grid sx={{ width: "100%" }}>
          <MxLoading variant="gradient" />
        </Grid>
      )}

      {!isLoading && hasError && (
        <Fade in={hasError}>
          <Box sx={{ width: "100%" }}>{errorComponent}</Box>
        </Fade>
      )}

      {!isLoading && !hasError && isEmpty && (
        <Fade in={isEmpty}>
          <Box sx={{ width: "100%" }}>{emptyComponent}</Box>
        </Fade>
      )}

      {!isLoading && !hasError && !isEmpty && (
        <Fade in={!isLoading && !hasError && !isEmpty}>
          <Grid sx={{ width: "100%" }}>{listComponent}</Grid>
        </Fade>
      )}

      {!isLoading && !hasError && !isEmpty && paginationComponent && (
        <Fade in={!isLoading && !hasError && !isEmpty}>
          <Grid sx={{ width: "100%" }}>{paginationComponent}</Grid>
        </Fade>
      )}
    </Grid>
  );
};

export default MxListCasesRenderTemplateTemplate;
